import {Action} from 'redux';
import {isType} from 'typescript-fsa';
import {mergeArraysWithHashmap} from '../../../utilities/helpers/reducer-helpers';
import * as actions from './actions';
import {NotificationSettingsState} from './types';
import {NotificationSettings} from '../../../api/api';

const initialState: NotificationSettingsState = {
  notificationSettingsHashmap: {},
  pending: false,
  success: false,
  deviceRetrivalFailed: false,
};

export const notificationSettingsReducer = (state = initialState, action: Action): NotificationSettingsState => {
  if (isType(action, actions.getNotificationSettingsAction.started)) {
    return {
      ...state,
      pending: true,
      deviceRetrivalFailed: false,
    };
  }

  if (isType(action, actions.getNotificationSettingsAction.done)) {
    return {
      ...state,
      notificationSettingsHashmap: mergeArraysWithHashmap(
        state.notificationSettingsHashmap,
        action.payload.result,
        (setting) => setting.deviceId!,
      ),
      pending: false,
      deviceRetrivalFailed: false,
    };
  }

  if (isType(action, actions.getNotificationSettingsAction.failed)) {
    return {
      ...state,
      pending: false,
      deviceRetrivalFailed: true,
    };
  }

  if (isType(action, actions.saveLimitSettingAction.started)) {
    return {
      ...state,
      success: false,
    };
  }

  // Add or update based on result from backend
  if (isType(action, actions.saveLimitSettingAction.done)) {
    let notificationSettingsListCopy = {
      ...state.notificationSettingsHashmap,
    };
    if (action.payload.result.deviceId) {
      let deviceNotificationSettings = notificationSettingsListCopy[action.payload.result.deviceId];

      if (deviceNotificationSettings === undefined) {
        deviceNotificationSettings = new Array<NotificationSettings>();
      } else {
        deviceNotificationSettings = [...deviceNotificationSettings];
      }

      // Check if the device is already in the list
      let settingIndex = deviceNotificationSettings.findIndex(
        (notificationSetting) => notificationSetting.id === action.payload.result.id,
      );

      // If yes - update with limit
      if (settingIndex > -1) {
        let deviceNotificationSettingIndexCopy = {...deviceNotificationSettings[settingIndex]};
        deviceNotificationSettingIndexCopy.limit = action.payload.result.limit;

        let deviceNotificationSettingsCopy = [...deviceNotificationSettings];
        deviceNotificationSettingsCopy[settingIndex] = deviceNotificationSettingIndexCopy as NotificationSettings;
        notificationSettingsListCopy[action.payload.result.deviceId] = deviceNotificationSettingsCopy;
      } else {
        // If no - add whole object to list
        deviceNotificationSettings.push(action.payload.result);
        notificationSettingsListCopy[action.payload.result.deviceId] = deviceNotificationSettings;
      }

      return {
        ...state,
        notificationSettingsHashmap: notificationSettingsListCopy,
        success: true,
      };
    }
  }

  if (isType(action, actions.saveLimitSettingAction.failed)) {
    return {
      ...state,
      pending: false,
    };
  }

  if (isType(action, actions.saveEmailSettingAction.started)) {
    return {
      ...state,
      success: false,
    };
  }

  // Add or update based on result from backend
  if (isType(action, actions.saveEmailSettingAction.done)) {
    let notificationSettingsListCopy = {
      ...state.notificationSettingsHashmap,
    };
    if (action.payload.result.deviceId) {
      let deviceNotificationSettings = notificationSettingsListCopy[action.payload.result.deviceId];

      if (deviceNotificationSettings === undefined) {
        deviceNotificationSettings = new Array<NotificationSettings>();
      } else {
        deviceNotificationSettings = [...deviceNotificationSettings];
      }

      // Check if the device is already in the list
      let settingIndex = deviceNotificationSettings.findIndex(
        (notificationSetting) => notificationSetting.id === action.payload.result.id,
      );

      // If yes - update with limit
      if (settingIndex > -1) {
        let deviceNotificationSettingIndexCopy = {...deviceNotificationSettings[settingIndex]};
        deviceNotificationSettingIndexCopy.emailUserWhenExceedingLimit =
          action.payload.result.emailUserWhenExceedingLimit;

        let deviceNotificationSettingsCopy = [...deviceNotificationSettings];
        deviceNotificationSettingsCopy[settingIndex] = deviceNotificationSettingIndexCopy as NotificationSettings;
        notificationSettingsListCopy[action.payload.result.deviceId] = deviceNotificationSettingsCopy;
      } else {
        // If no - add whole object to list
        deviceNotificationSettings.push(action.payload.result);
        notificationSettingsListCopy[action.payload.result.deviceId] = deviceNotificationSettings;
      }

      return {
        ...state,
        notificationSettingsHashmap: notificationSettingsListCopy,
        success: true,
      };
    }
  }

  if (isType(action, actions.saveEmailSettingAction.failed)) {
    return {
      ...state,
      pending: false,
    };
  }

  if (isType(action, actions.saveWebSettingAction.started)) {
    return {
      ...state,
      success: false,
    };
  }

  // Add or update based on result from backend
  if (isType(action, actions.saveWebSettingAction.done)) {
    let notificationSettingsListCopy = {
      ...state.notificationSettingsHashmap,
    };
    if (action.payload.result.deviceId) {
      let deviceNotificationSettings = notificationSettingsListCopy[action.payload.result.deviceId];

      if (deviceNotificationSettings === undefined) {
        deviceNotificationSettings = new Array<NotificationSettings>();
      } else {
        deviceNotificationSettings = [...deviceNotificationSettings];
      }

      // Check if the device is already in the list
      let settingIndex = deviceNotificationSettings.findIndex(
        (notificationSetting) => notificationSetting.id === action.payload.result.id,
      );

      // If yes - update with limit
      if (settingIndex > -1) {
        let deviceNotificationSettingIndexCopy = {...deviceNotificationSettings[settingIndex]};
        deviceNotificationSettingIndexCopy.showNotificationWeb =
          action.payload.result.showNotificationWeb;

        let deviceNotificationSettingsCopy = [...deviceNotificationSettings];
        deviceNotificationSettingsCopy[settingIndex] = deviceNotificationSettingIndexCopy as NotificationSettings;
        notificationSettingsListCopy[action.payload.result.deviceId] = deviceNotificationSettingsCopy;
      } else {
        // If no - add whole object to list
        deviceNotificationSettings.push(action.payload.result);
        notificationSettingsListCopy[action.payload.result.deviceId] = deviceNotificationSettings;
      }

      return {
        ...state,
        notificationSettingsHashmap: notificationSettingsListCopy,
        success: true,
      };
    }
  }

  if (isType(action, actions.saveEmailSettingAction.failed)) {
    return {
      ...state,
      pending: false,
    };
  }

  return state;
};
